<ng-container *ngIf="!loading; else loadingBlock">
  <ng-container *ngIf="!loadingError">
    <div class="partners d--flex d--none--sm" *ngIf="partners">
      <a
        *ngFor="let partner of partners"
        class="partners__link"
        [airLink]="partner.url"
        [userEventSource]="userEventSource"
        [userEventLabel]="partner.title"
      >
        <img *ngIf="partner.logo" [src]="partner.logo.cropUrl" [alt]="partner.title" />
      </a>
    </div>
    <div class="partners d--show--sm" *ngIf="displayPartners">
      <ul class="d--flex" [@partner]="isAnimating ? 'out' : 'in'">
        <li *ngFor="let partner of displayPartners" class="partners__link">
          <a class="partners__link" [airLink]="partner.url" [userEventSource]="userEventSource" [userEventLabel]="partner.title">
            <img *ngIf="partner.logo" [src]="partner.logo.cropUrl" [alt]="partner.title" />
          </a>
        </li>
      </ul>
    </div>
  </ng-container>
</ng-container>

<ng-template #loadingBlock>
  <div class="partners d--flex loading">
    <a *ngFor="let skeleton of [] | range: 4" class="partners__link">
      <img />
    </a>
  </div>
</ng-template>
